import { gql } from 'graphql-request'

export const CREATE_BOOK_COLLECTION = gql`
  mutation CreateBookCollection(
    $createBookCollectionInput: CreateBookCollectionInput!
  ) {
    createBookCollection(
      createBookCollectionInput: $createBookCollectionInput
    ) {
      message
    }
  }
`
